module.exports = __webpack_public_path__ + "static/media/Comercio.291b6341.svg";